

































import Vue from 'vue'
import activeForm from '@/components/Ui/ActiveForm/ActiveForm.vue'
import UiSteps from '@/components/Ui/Steps/Steps.vue'
import {DateTime} from 'luxon'
import firstStep from './steps/step_1.vue'
import secondStep from './steps/step_2.vue'
import thirdStep from './steps/step_3.vue'
import fourthStep from './steps/step_4.vue'
import Poll from '@/models/polls/Poll'
import {MSGR_TG, MSGR_VK, MSGRS_LIST} from '@/constants'
export default Vue.extend({
  components: {
    activeForm,
    UiSteps,
    firstStep,
    secondStep,
    thirdStep,
    fourthStep
  },
  data () {
    return {
      formData: {},
      steps: [
        {label: this.$t('polls.poll')},
        {label: this.$t('newsletters.steps.recipients')},
        {label: this.$t('newsletters.steps.date')},
        // {label: this.$t('newsletters.steps.settings')}
      ],
      activeStep: 1,
      pollId: ''
    }
  },
  methods: {
    next () {
      if (++this.activeStep > 3) this.activeStep = 0;
    },
    prev () {
      if (--this.activeStep < 0) this.activeStep = 0;
    },
    setData (data: {}) {
      console.log('LOG: setData -> data', data)
      this.$set(this, 'formData', Object.assign(this.formData, data))
    },
    async createPoll (data: {}): Promise<void> {
      try {
        if (!this.pollId) {
          let {poll} = await this.$store.dispatch('poll/create', data)
          this.pollId = poll.id
          await this.$store.dispatch('poll/addFilter', {poll_id: this.pollId, query: {msgrs: MSGRS_LIST}})
          await this.loadPoll();
        } else {
          await this.updatePoll(data)
        }

        if (this.activeStep === 1) {
          this.next()
        }
      } catch (error) {
        // @ts-ignore
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('newsletters.send_error_notification'),
          type: 'error'
        });
      }
    },
    async loadPoll (): Promise<void> {
      await this.$store.dispatch('poll/get', this.pollId)
    },
    async updatePoll (data: {}) {
      await this.$store.dispatch('poll/update', {poll_id: this.pollId, ...data})
    },
    async onFormCancel () {
    },
    async onFormSubmit (data: any) {
      try {
        // @ts-ignore
        await this.updatePoll({send_at: this.formData.send_at, finish_at: this.formData.finish_at})
        // @ts-ignore
        await this.$store.dispatch('mailing/setReady', this.poll.getMailingId())
        this.$router.push({name: 'pollsPage', params: {id: this.pollId}})
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('polls.created_success'),
          type: 'success'
        });
      } catch (error) {
        console.error('LOG: onFormSubmit -> error', error)
        // @ts-ignore
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('newsletters.send_error_notification'),
          type: 'error'
        });
      }
    }
  },
  computed: {
    poll (): Poll | false {
      if (this.pollId) {
        return this.$store.state.poll.polls[this.pollId]
      } else {
        return false;
      }
    }
  }
})
